import { render } from "./Header.vue?vue&type=template&id=72f9d1ab&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=72f9d1ab&lang=scss&scoped=true"

import exportComponent from "/Users/ijj/sy-website/template1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72f9d1ab"]])

export default __exports__